export default function CTABanner() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20modern%20ecommerce%20fulfillment%20scene%20with%20neatly%20packed%20shipping%20boxes%20on%20a%20warm%20wooden%20table%20alongside%20a%20laptop%20showing%20order%20tracking%20dashboard%2C%20warm%20golden%20hour%20light%20streaming%20through%20large%20windows%2C%20cream%20and%20warm%20amber%20tones%2C%20editorial%20photography%2C%20wide%20composition%2C%20no%20text%20no%20logos%2C%20successful%20business%20atmosphere&width=1800&height=800&seq=cta-bg-acbuy-v2&orientation=landscape"
        alt="ACBuySpreadsheet start sourcing today"
        title="Get started with ACBuySpreadsheet product sourcing"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/40 to-black/50"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
          ACBUY SPREADSHEET
        </h2>
        <p className="mt-5 text-base md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
          Start using ACBuySpreadsheet today and improve your product sourcing efficiency instantly with a proven, structured system.
        </p>

        <div className="mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-foreground-900 text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap group"
          >
            <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-white text-sm"></i>
              </span>
            </span>
            <span>Buy It Now</span>
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
              <i className="ri-arrow-right-up-line text-white"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}